module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "title": "忘记密码"
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "ui-content edi-forgot",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onCheckSubmit.apply(null, arguments)
      }
    }
  }, [_c('ul', {
    staticClass: "ui-listview ui-listview-inset"
  }, [_c('li', {
    staticClass: "ui-listview-one-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephone),
      expression: "telephone"
    }],
    staticClass: "ui-align-center",
    attrs: {
      "type": "text",
      "name": "telephone",
      "placeholder": "手机号"
    },
    domProps: {
      "value": (_vm.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telephone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('fieldset', {
    staticClass: "ui-controlgroup"
  }, [_c('input', {
    staticClass: "submit",
    class: {
      'ui-disable': _vm.submitDisable
    },
    attrs: {
      "type": "submit",
      "value": "确定"
    }
  })]), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5aea87f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Forgot.vue
// module id = 574
// module chunks = 1